module.exports = __webpack_public_path__ + "img/au.37a5442.svg";